let parser = new DOMParser();
export default function (str) {
  if (typeof str === 'string') {
    str = window.escape(str).replace(/%26/g, '&').replace(/%23/g, '#').replace(/%3B/g, ';');
    let element = parser.parseFromString(`<div>${str}</div>`, 'text/html');
    if (element.body.textContent) {
      str = element.body.textContent;
    }
    return window.unescape(str).replace(/\u00A0/g, '\u0020');
  } else {
    throw new Error("Trying to decode entities on something that isn't a string");
  }
}